var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": "svg-1299738496--1789876998-title",
    viewBox: "-7 -5 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001138",
    d: "M15.45 4.41A4.52 4.52 0 0 1 11.9.42V.01H8.66v12.85c0 1.5-1.23 2.72-2.73 2.71-.85 0-1.65-.4-2.16-1.07-.91-1.2-.68-2.91.52-3.81.71-.54 1.63-.7 2.47-.43V6.97C3.51 6.51.51 8.79.06 12.04c-.25 1.82.35 3.66 1.64 4.97a5.964 5.964 0 0 0 8.42.1 5.93 5.93 0 0 0 1.79-4.26V6.29c1.31.94 2.88 1.44 4.49 1.44V4.51c-.32 0-.63-.03-.94-.1Z"
  })));
};
export default SvgTiktok;